import { Preferences } from '@capacitor/preferences';
import { isNativeMobile } from './platform';

/**
 * Session storage utilities for Capacitor mobile app
 * Uses Capacitor Preferences on native mobile, sessionStorage on web
 */

const SESSION_TOKEN_KEY = 'session_token';

/**
 * Store session token
 * @param {string} token - Session token to store
 */
export const setSessionToken = async (token) => {
  if (isNativeMobile()) {
    await Preferences.set({
      key: SESSION_TOKEN_KEY,
      value: token
    });
  } else {
    // On web, cookies are handled by the browser automatically
    // This is just for backup/reference
    sessionStorage.setItem(SESSION_TOKEN_KEY, token);
  }
};

/**
 * Get stored session token
 * @returns {Promise<string|null>} Session token or null if not found
 */
export const getSessionToken = async () => {
  if (isNativeMobile()) {
    const { value } = await Preferences.get({ key: SESSION_TOKEN_KEY });
    return value;
  } else {
    return sessionStorage.getItem(SESSION_TOKEN_KEY);
  }
};

/**
 * Remove session token (logout)
 */
export const removeSessionToken = async () => {
  if (isNativeMobile()) {
    await Preferences.remove({ key: SESSION_TOKEN_KEY });
  } else {
    sessionStorage.removeItem(SESSION_TOKEN_KEY);
  }
};

/**
 * Clear all stored preferences (full logout)
 */
export const clearAllPreferences = async () => {
  if (isNativeMobile()) {
    await Preferences.clear();
  } else {
    sessionStorage.clear();
  }
};
